export class LFTabChangeEvent {
    public tabId: string;

    public hasError: boolean;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/components/platform/lf-tabbedpane/lf-tab-change-event.ts